// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { diadem16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-diadem': IconDiadem;
    }
}

/**
 * The icon component for the 'diadem' icon
 */
export class IconDiadem extends IconSvg {
    public constructor() {
        super(diadem16X16);
    }
}

registerIconSvg('icon-diadem', IconDiadem);
export const iconDiademTag = 'nimble-icon-diadem';
